import { Lang, LangValues } from '../type';

export const ensureLang = (lang: string): lang is LangValues => {
  return Object.values(Lang).includes(lang as Lang);
};
